import {
  Box,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useMediaQuery,
} from "@chakra-ui/react";
import { Route, Routes } from "react-router-dom";
import Clone from "./components/tables/Clone";
import CommoditiesTable from "./components/tables/CommoditiesTable";
import ExternalCommoditiesTable from "./components/tables/ExternalCommoditiesTable";
import ExternalSourceTable from "./components/tables/ExternalSourceTable";
import PublicCommoditiesTable from "./components/tables/PublicCommoditiesTable";
import UsersTable from "./components/tables/UsersTable";
import AdminPageContainer from "./pages/admin/AdminPageContainer";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/login/Login";
import About from "./pages/public/About";
import PublicLayout from "./pages/public/PublicLayout";
import CommodityDetails from "./pages/user/commodities/details/CommodityDetails";
import UserPageContainer from "./pages/user/UserPageContainer";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
//
function App() {
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Routes>
      <Route path="*" element={<>Not Found</>} />

      <Route
        path="/"
        element={
          <PublicRoute>
            <PublicLayout>
              <Tabs variant="enclosed" isFitted={!isLargerThan900} p="2">
                <TabList>
                  <Tab _selected={{ color: "white", bg: "primary" }}>
                    Commodities
                  </Tab>
                  <Tab _selected={{ color: "white", bg: "primary" }}>
                    Outside Sources
                  </Tab>
                </TabList>
                <TabPanels>
                  <TabPanel>
                    <PublicCommoditiesTable isPublic={true} />
                  </TabPanel>
                  <TabPanel>
                    <Clone />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </PublicLayout>
          </PublicRoute>
        }
      />
      <Route
        path="/about"
        element={
          <PublicRoute>
            <About />
          </PublicRoute>
        }
      />
      <Route
        path="commodity/public/:id"
        element={
          <PublicRoute>
            <PublicLayout>
              <CommodityDetails isPublic={true} />
            </PublicLayout>
          </PublicRoute>
        }
      />
      <Route
        path="/auth"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute roles={["ADMIN", "INDIVIDUAL", "ESTABLISHMENT"]}>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/user/dashboard"
        element={
          <PrivateRoute roles={["INDIVIDUAL", "ESTABLISHMENT"]}>
            <UserPageContainer />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/user/dashboard/commodity/:id"
        element={
          <PrivateRoute roles={["INDIVIDUAL", "ESTABLISHMENT"]}>
            <CommodityDetails />
          </PrivateRoute>
        }
      ></Route>
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute roles={["ADMIN"]}>
            <AdminPageContainer />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;
